export default __webpack_public_path__ + "static/media/example-zjz.439ff74c.png";